import { render, staticRenderFns } from "./BullQuaratineTwo.vue?vue&type=template&id=47cf0a52&scoped=true&"
import script from "./BullQuaratineTwo.vue?vue&type=script&lang=js&"
export * from "./BullQuaratineTwo.vue?vue&type=script&lang=js&"
import style0 from "./BullQuaratineTwo.vue?vue&type=style&index=0&id=47cf0a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cf0a52",
  null
  
)

export default component.exports